import React from 'react';
import LazyImage from '../LazyImage';
import './Footer.css';
import logo from '../../assets/images/logo-dark.webp';
import facebookIcon from '../../assets/icons/facebook.png';
import instagramIcon from '../../assets/icons/instagram.png';
import phone from '../../assets/icons/phone.png';
import mobile from '../../assets/icons/mobile.png';
import mail from '../../assets/icons/mail.png';
import location from '../../assets/icons/location.png';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        {/* First Row */}
        <div className='footer-content'>
          {/* Left Column - 40% */}
          <div className='footer-left'>
            <div className='footer-logo'>
              <LazyImage src={logo} alt='PFGS Logo' />
            </div>
            <div className='footer-description'>
              PFGS is a trusted Australian firm offering expert tax return preparation, bookkeeping, and financial advisory services. With a
              client-first approach and qualified professionals, we help individuals and businesses stay compliant, grow smarter, and save more —
              year-round.
            </div>
          </div>

          {/* Right Column - 60% */}
          <div className='footer-right'>
            {/* Quick Links - 25% */}
            <div className='footer-column'>
              <h3 className='footer-title'>Quick Links</h3>
              <ul className='footer-menu'>
                <li>
                  <a href='/'>Home</a>
                </li>
                <li>
                  <a href='/about'>About Us</a>
                </li>
                <li>
                  <a href='/contact'>Contact Us</a>
                </li>
              </ul>
            </div>

            {/* Services - 25% */}
            <div className='footer-column'>
              <h3 className='footer-title'>Services</h3>
              <ul className='footer-menu'>
                <li>
                  <a href='/accounting-services'>Accounting Services</a>
                </li>
                <li>
                  <a href='/individual-tax-return'>Tax Service</a>
                </li>
                {/* <li>
                  <a href='/accounting-services'>Superannuation</a>
                </li>
                <li>
                  <a href='/accounting-services'>Financial Service</a>
                </li> */}
              </ul>
            </div>

            {/* Contact Info - 50% */}
            <div className='footer-column footer-contact'>
              <h3 className='footer-title'>Contact Info</h3>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={phone} alt='' />
                </span>
                <span>(02) 9476 8531</span>
              </div>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={mobile} alt='' />
                </span>
                <span>0433-209-411</span>
              </div>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={mail} alt='' />
                </span>
                <span>mandeep@pfgs.com.au</span>
              </div>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={location} alt='' />
                </span>
                <div>
                  <a href='/location-sydney'>
                    <span className='contact-icon-location-text'>Sydney Office: </span>
                    <span>G2/5 McGill Street, Lewisham NSW 2049, Australia</span>
                  </a>
                </div>
              </div>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={location} alt='' />
                </span>
                <div>
                  <a href='/location-orange'>
                    <span className='contact-icon-location-text'>Regional Office: </span>
                    <span>Office 4, 3 Hampden Avenue, Orange NSW 2800, Australia</span>
                  </a>
                </div>
              </div>
              <div className='contact-item'>
                <span className='contact-icon'>
                  <img width='20' src={location} alt='' />
                </span>
                <div>
                  <a href='/location-mohali'>
                    <span className='contact-icon-location-text'>India Office: </span>
                    <span>SCF 3, Industrial Area, Phase 1, Mohali, Punjab, India</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className='footer-divider'></div>

        {/* Second Row */}
        <div className='footer-bottom'>
          <div className='footer-copyright'>© 2025 PFGS. All rights reserved.</div>
          <div className='footer-social'>
            <a href='https://www.facebook.com/profile.php?id=61578288867434' className='social-link'>
              <img src={facebookIcon} alt='Facebook' />
            </a>
            <a href='https://www.instagram.com/progressive_financial/' className='social-link'>
              <img src={instagramIcon} alt='LinkedIn' />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
